/**
 * GamePlayerView — view do papel player.
 *
 * Renderiza apenas o slide corrente. Sem controles de navegação — o aluno
 * acompanha o que o mestre mostra.
 */

import { useEffect } from 'react'

import { useAdapter } from '../adapter'
import { InteractionModeBadge } from '../components/InteractionModeBadge'
import { SlideShell } from '../components/SlideShell'
import { ThemeToggle } from '../components/ThemeToggle'
import { XpBadge } from '../components/XpBadge'
import { useSessionState } from '../hooks/useSessionState'
import type { Manifest } from '../types/manifest'
import { SlideRouter } from './SlideRouter'

interface Props {
  manifest: Manifest
}

export function GamePlayerView({ manifest }: Props) {
  const { slideIndex } = useSessionState()
  const slide = manifest.slides[slideIndex]
  const isMission = slide?.type === 'mission'
  const isFullbleed = isMission || slide?.type === 'custom'

  // Mestre encerrou a aula → leva o participante ao preview público da mesma
  // aula para navegação livre. Só o player escuta este evento (o master não
  // monta esta view). Fallback de path via gameSlug do manifest.
  const adapter = useAdapter()
  useEffect(() => {
    return adapter.on('sessionEnded', (msg: { redirectPath?: string | null }) => {
      const path = msg?.redirectPath ?? `/module_lab/preview/${manifest.gameSlug}`
      window.location.assign(path)
    })
  }, [adapter, manifest.gameSlug])

  return (
    <>
      <SlideShell variant={isFullbleed ? 'fullbleed' : 'default'}>
        <SlideRouter slide={slide} />
      </SlideShell>
      {isMission && <InteractionModeBadge />}
      <XpBadge />
      <ThemeToggle position="bottom-right" />
    </>
  )
}
